/* =====================================================================================================================
   batida-v7-onas.js: small interactions of the new "O nas / Historia" page (sections/batida-v7-onas-*), rebuilt from
   Aleksandra's prototype script (_26, view "ONas"):
   - chapter menu: smooth jump to the chapter + the chapter you are reading lights up (.is-on)
   - numbers count up once when they come into view (data-v7o-num data-from/data-to)
   - "Czytaj dalej" / "Zwiń", timeline steps + arrows, generation cards turn over on tap (touch screens)
   - the old SEO text folds under "Czytaj dalej", the two dark buttons follow the mouse a little
   Everything still reads without JS; motion is off for prefers-reduced-motion. Works again after a theme editor reload.
   ===================================================================================================================== */
(function () {
  'use strict';
  var mq = window.matchMedia ? function (q) { return window.matchMedia(q).matches; } : function () { return false; };
  var reduce = mq('(prefers-reduced-motion: reduce)');

  /* ---------- clicks (delegated, so re-rendered sections keep working) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // jump to a chapter
    var a = t.closest('.v7o a[href^="#on-"]');
    if (a) {
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (window.history && history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      }
      return;
    }

    // "Czytaj dalej" / "Zwiń"
    var m = t.closest('[data-v7o-more]');
    if (m) {
      var box = document.getElementById(m.getAttribute('data-v7o-more'));
      if (!box) return;
      if (!m.hasAttribute('data-more')) m.setAttribute('data-more', m.textContent);
      box.hidden = !box.hidden;
      m.textContent = box.hidden ? m.getAttribute('data-more') : (m.getAttribute('data-less') || m.getAttribute('data-more'));
      m.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
      return;
    }

    // timeline: a step or an arrow
    var st = t.closest('[data-v7o-tl-i]');
    if (st) { tlGo(st.closest('[data-v7o-tl]'), +st.getAttribute('data-v7o-tl-i')); return; }
    var ar = t.closest('[data-v7o-tl-step]');
    if (ar) {
      var root = ar.closest('[data-v7o-tl]');
      tlGo(root, tlCur(root) + (+ar.getAttribute('data-v7o-tl-step')));
      return;
    }

    // generation card: tap turns it over on touch screens (mouse = hover, keyboard = focus, both in CSS)
    var g = t.closest('[data-v7o-gen]');
    if (g && mq('(hover: none)')) { g.classList.toggle('is-flip'); return; }

    // old SEO text: fold / unfold
    var cb = t.closest('[data-v7o-clamp-btn]');
    if (cb) {
      var rte = cb.parentNode.querySelector('[data-v7o-clamp]');
      if (!rte) return;
      if (!cb.hasAttribute('data-more')) cb.setAttribute('data-more', cb.textContent);
      var folded = rte.classList.toggle('is-clamp');
      cb.textContent = folded ? cb.getAttribute('data-more') : (cb.getAttribute('data-less') || cb.getAttribute('data-more'));
      cb.setAttribute('aria-expanded', folded ? 'false' : 'true');
    }
  });

  // arrow keys move along the timeline
  document.addEventListener('keydown', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-v7o-tl-i]') : null;
    if (b && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      e.preventDefault();
      var root = b.closest('[data-v7o-tl]');
      var n = tlGo(root, tlCur(root) + (e.key === 'ArrowRight' ? 1 : -1));
      var bs = root.querySelectorAll('[data-v7o-tl-i]');
      if (bs[n]) bs[n].focus();
    }
  });

  /* ---------- timeline ---------- */
  function tlCur(root) {
    var bs = root ? root.querySelectorAll('[data-v7o-tl-i]') : [];
    for (var i = 0; i < bs.length; i++) if (bs[i].getAttribute('aria-pressed') === 'true') return i;
    return 0;
  }
  function tlGo(root, n) {
    if (!root) return 0;
    var bs = root.querySelectorAll('[data-v7o-tl-i]'), ps = root.querySelectorAll('[data-v7o-tl-p]');
    if (!bs.length) return 0;
    n = (n + bs.length) % bs.length;
    for (var i = 0; i < bs.length; i++) bs[i].setAttribute('aria-pressed', i === n ? 'true' : 'false');
    for (var j = 0; j < ps.length; j++) ps[j].hidden = j !== n;
    // phones: the row scrolls sideways - bring the chosen step into view (without moving the page)
    var row = bs[n].parentNode;
    if (row.scrollWidth > row.clientWidth + 2) {
      var left = bs[n].offsetLeft - (row.clientWidth - bs[n].offsetWidth) / 2;
      if (row.scrollTo) row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); else row.scrollLeft = left;
    }
    return n;
  }

  /* ---------- chapter menu: light up the chapter being read ---------- */
  var ticking = false;
  function spy() {
    ticking = false;
    var navs = document.querySelectorAll('[data-v7o-nav]');
    if (!navs.length) return;
    var best = null, lim = window.innerHeight * 0.4;
    var chs = document.querySelectorAll('[data-v7o-ch]');
    for (var i = 0; i < chs.length; i++) if (chs[i].getBoundingClientRect().top < lim) best = chs[i].id;
    for (var k = 0; k < navs.length; k++) {
      var links = navs[k].querySelectorAll('.v7o-nav__a'), on = null;
      for (var j = 0; j < links.length; j++) {
        var hit = best !== null && links[j].getAttribute('href') === '#' + best;
        links[j].classList.toggle('is-on', hit);
        if (hit) { links[j].setAttribute('aria-current', 'true'); on = links[j]; } else links[j].removeAttribute('aria-current');
      }
      // phones: the menu scrolls sideways - keep the lit chapter visible (without moving the page)
      var row = navs[k].querySelector('.v7o-nav__in');
      if (on && row && row.scrollWidth > row.clientWidth + 2 && on !== row.__v7oOn) {
        row.__v7oOn = on;
        var left = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
        if (row.scrollTo) row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' }); else row.scrollLeft = left;
      }
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(spy); } }, { passive: true });
  window.addEventListener('resize', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(spy); } });

  /* ---------- numbers count up (1990 from 1950, 3, 6, 50) ---------- */
  function nums() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('[data-v7o-num]');
    for (var i = 0; i < els.length; i++) (function (el) {
      if (el.__v7o) return;
      el.__v7o = 1;
      var to = parseInt(el.getAttribute('data-to'), 10), fr = parseInt(el.getAttribute('data-from'), 10);
      if (isNaN(to) || isNaN(fr) || to === fr) return;
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return; // already on screen at load: leave the final number
      el.textContent = fr;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now();
        (function step(now) {
          var p = Math.min(1, (now - t0) / 1400);
          el.textContent = Math.round(fr + (to - fr) * (1 - Math.pow(1 - p, 3)));
          if (p < 1) window.requestAnimationFrame(step); else el.textContent = to;
        })(t0);
      }, { threshold: 0.5 });
      io.observe(el);
    })(els[i]);
  }

  /* ---------- old SEO text: fold when long ---------- */
  function clamp() {
    var boxes = document.querySelectorAll('[data-v7o-clamp]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], btn = box.parentNode.querySelector('[data-v7o-clamp-btn]');
      if (!btn || box.__v7o) continue;
      box.__v7o = 1;
      box.classList.add('is-clamp');
      if (box.scrollHeight <= box.clientHeight + 24) { box.classList.remove('is-clamp'); continue; }
      btn.hidden = false;
    }
  }

  /* ---------- the dark buttons follow the mouse a little (prototype "bt-mag") ---------- */
  var magT = false, mx = 0, my = 0;
  function mag() {
    magT = false;
    var bs = document.querySelectorAll('[data-v7o-mag]');
    for (var i = 0; i < bs.length; i++) {
      var r = bs[i].getBoundingClientRect(), dx = mx - (r.left + r.width / 2), dy = my - (r.top + r.height / 2);
      bs[i].style.transform = Math.sqrt(dx * dx + dy * dy) < 110 ? 'translate(' + (dx * 0.25).toFixed(1) + 'px,' + (dy * 0.35).toFixed(1) + 'px)' : '';
    }
  }
  if (!reduce && mq('(hover: hover) and (pointer: fine)')) {
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!magT && document.querySelector('[data-v7o-mag]')) { magT = true; window.requestAnimationFrame(mag); }
    }, { passive: true });
  }

  function init() { nums(); clamp(); spy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  // theme editor: picking a timeline step in the sidebar shows it, picking the old SEO text unfolds it
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.hasAttribute('data-v7o-tl-i')) tlGo(t.closest('[data-v7o-tl]'), +t.getAttribute('data-v7o-tl-i'));
    var rte = t.closest('[data-v7o-clamp]');
    if (rte && rte.classList.contains('is-clamp')) { var cb = rte.parentNode.querySelector('[data-v7o-clamp-btn]'); if (cb) cb.click(); }
  });
})();
